module.exports = __webpack_public_path__ + "img/qian-2.aa2d189b.svg";